<template>
  <hl-Modal
    class="text-center error-modal"
    iconClass="budicon-cloud-server text-warning"
    title="Oops! ️️🕵️‍♂️ Noe gikk galt. Vennligst prøv på nytt."
  >
    <div class="my-4">
      <code>{{ error }}</code>
    </div>
    <hl-Loader v-if="loading" variation="warning" />

    <div>
      <!--<button class="btn btn-warning mx-2">Prøv igjen</button>-->
      <button class="btn btn-outline-secondary mx-2" @click="closeModal">Avbryt</button>
    </div>
  </hl-Modal>
</template>

<script>
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import Loader from '@modules/husleie-framework/src/components/loaders/Loader.vue';

export default {
  components: {
    'hl-Modal': Modal,
    'hl-Loader': Loader,
  },

  props: {
    error: {
      type: String,
    },
  },

  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style scoped lang="scss">
.error-modal {
  z-index: 1999;
}
</style>
